const GPT_IMAGE_2_ASPECT_RATIOS = [
  ['4:3', '4:3 横向'], ['3:4', '3:4 竖向'], ['1:1', '1:1 正方形'],
  ['16:9', '16:9 宽屏'], ['9:16', '9:16 竖屏'], ['3:2', '3:2 横向'],
  ['2:3', '2:3 竖向'], ['2:1', '2:1 超宽'], ['1:2', '1:2 超长'],
].map(([value, label]) => ({ value, label }));

export const GPT_IMAGE_2_CONFIG = {
  type: 'gptImage2',
  modelId: 'openai/gpt-image-2',
  modelLabel: 'OPENAI · IMAGE 2',
  taskType: 'gpt-image-2',
  title: 'GPT 2 图像生成',
  icon: '✨',
  accent: '#1463ff',
  soft: '#eaf1ff',
  imageLimit: 6,
  ratioParam: 'image_size',
  defaultAspectRatio: '4:3',
  aspectRatios: GPT_IMAGE_2_ASPECT_RATIOS,
  editAspectRatios: [
    { value: 'auto', label: '自动匹配参考图比例' },
    ...GPT_IMAGE_2_ASPECT_RATIOS,
  ],
  supportsQuality: true,
  defaultQuality: 'low',
  supportsNumImages: false,
  supportsWebSearch: false,
  supportsOutputFormatSelection: false,
  defaultOutputFormat: 'png',
};

export const NANO_BANANA_2_CONFIG = {
  type: 'nanoBanana2',
  modelId: 'fal-ai/nano-banana-2',
  modelLabel: 'GOOGLE · NANO 2',
  taskType: 'nano-banana-2',
  title: 'Nano 2 图像生成',
  icon: '🍌',
  accent: '#16794d',
  soft: '#e8f7ef',
  imageLimit: 14,
  ratioParam: 'aspect_ratio',
  defaultAspectRatio: 'auto',
  aspectRatios: [
    ['auto', '自动匹配'], ['1:1', '1:1 正方形'], ['16:9', '16:9 宽屏'],
    ['9:16', '9:16 竖屏'], ['4:3', '4:3 横向'], ['3:4', '3:4 竖向'],
    ['3:2', '3:2 横向'], ['2:3', '2:3 竖向'], ['5:4', '5:4 横向'],
    ['4:5', '4:5 竖向'], ['21:9', '21:9 超宽'],
  ].map(([value, label]) => ({ value, label })),
  supportsQuality: false,
  supportsNumImages: true,
  fixedNumImages: 1,
  showNumImagesControl: false,
  supportsWebSearch: false,
  supportsOutputFormatSelection: false,
  defaultOutputFormat: 'png',
};
